<div class="mtm-breadcrumb-component">
  <div *ngIf="links.length <= 2; else otherCases">
    <ng-container *ngTemplateOutlet="breadcrumbTemplate"></ng-container>
  </div>
  <ng-template #otherCases>
    <div class="d-none d-sm-block">
      <ng-container *ngTemplateOutlet="breadcrumbTemplate"></ng-container>
    </div>
    <div class="d-sm-none">
      <div class="d-flex align-items-center">
        <!-- <div *ngIf="isReportingV2 && links.length > 1"
                     class="pointer home-icon d-flex justify-content-center align-items-center me-2"
                     (click)="redirectToReportDashboard()">
                    <img width="20" height="20" src="../../../../assets/svg/home-icon.svg" alt="Go to Home">
                </div> -->
        <div class="text-center">
          <ng-container *ngIf="isBrandCrumb(otherLinkForSmall[0]); else plainSmallBrandLabel">
            <ng-container
              *ngTemplateOutlet="
                brandSwitcherTemplate;
                context: { label: otherLinkForSmall[0].label, isActive: false }
              "></ng-container>
          </ng-container>
          <ng-template #plainSmallBrandLabel>
            <a class="m-2 link-label no-link">{{ otherLinkForSmall[0].label | translate }}</a>
          </ng-template>
        </div>
        <div ngbDropdown container="body">
          <div
            class="d-flex align-items-center dropdown-toggle pointer"
            *ngIf="otherLinkForSmall.length > 0"
            ngbDropdownToggle>
            <i class="ms-2 fa fa-ellipsis-h"></i>
          </div>
          <div ngbDropdownMenu>
            <div ngbDropdownItem *ngFor="let other of otherLinkForSmall; let i = index" [hidden]="other.hidden">
              <a
                *ngIf="i !== 0"
                class="m-2 link-label link-label-other text-black"
                [ngClass]="{ 'no-link': !other.url }"
                (click)="goToPage(other.url, other.queryParams)"
                >{{ other.label | translate }}</a
              >
            </div>
          </div>
        </div>
        <div
          class="breadcrumb-links align-items-center ms-1"
          *ngFor="let link of linkForSmall; let i = index"
          [class.d-none]="link.hidden"
          [class.d-flex]="!link.hidden">
          <a
            class="m-2 link-label"
            [ngClass]="{ 'no-link': !link.url, active: i === linkForSmall.length - 1 }"
            (click)="goToPage(link.url, link.queryParams)"
            >{{ link.label | translate }}</a
          >
          <i *ngIf="i != linkForSmall.length - 1" class="mtm-icon mtm-icon-right-triangle-black"></i>
        </div>
        <ng-container *ngTemplateOutlet="driveCompareChip"></ng-container>
      </div>
    </div>
  </ng-template>
</div>

<ng-template #breadcrumbTemplate>
  <div class="d-flex align-items-center">
    <!-- <div *ngIf="isReportingV2 && links.length > 1"
             class="pointer home-icon d-flex justify-content-center align-items-center me-2"
             (click)="redirectToReportDashboard()">
            <img width="20" height="20" src="../../../../assets/svg/home-icon.svg" alt="Go to Home">
        </div> -->
    <!-- <div *ngIf="shouldShowBackButton"
             class="pointer back-button d-flex justify-content-center align-items-center me-2" (click)="goBack()">
            <i class="mtm-icon mtm-icon-left-triangle-circle-black"></i>
        </div> -->
    <div ngbDropdown>
      <div
        class="d-flex align-items-center dropdown-toggle pointer"
        ngbDropdownToggle
        *ngIf="otherLinkForDesktop.length > 0">
        <i class="mtm-icon mtm-icon-left-triangle-circle-black"></i>
        <i class="ms-2 fa fa-ellipsis-h"></i>
      </div>
      <div ngbDropdownMenu>
        <div ngbDropdownItem *ngFor="let other of otherLinkForDesktop" [hidden]="other.hidden">
          <a
            class="m-2 link-label _700 link-label-other"
            [ngClass]="{ 'no-link': !other.url }"
            (click)="goToPage(other.url, other.queryParams)"
            >{{ other.label | translate }}</a
          >
        </div>
      </div>
    </div>
    <div
      class="breadcrumb-links align-items-center ms-1"
      *ngFor="let link of forCurrentUrl_linkForDesktop; let i = index"
      [class.d-none]="link.hidden"
      [class.d-flex]="!link.hidden">
      <ng-container *ngIf="i === 0 && otherLinkForDesktop.length === 0 && isBrandCrumb(link); else plainCrumb">
        <ng-container
          *ngTemplateOutlet="
            brandSwitcherTemplate;
            context: { label: link.label, isActive: i === forCurrentUrl_linkForDesktop.length - 1 }
          "></ng-container>
      </ng-container>
      <ng-template #plainCrumb>
        <a
          class="m-2 link-label"
          [ngClass]="{
            active: i === forCurrentUrl_linkForDesktop.length - 1,
            'no-link': !link.url || link.isCurrentUrl,
          }"
          (click)="goToPage(link.url, link.queryParams)"
          >{{ link.label | translate }}</a
        >
      </ng-template>
      <i *ngIf="i != linkForDesktop.length - 1" class="mtm-icon mtm-icon-right-triangle-black"></i>
    </div>
    <ng-container *ngTemplateOutlet="driveCompareChip"></ng-container>
  </div>
</ng-template>

<!-- Brand crumb as a sibling-switcher dropdown (mirrors the project breadcrumb node dropdowns) -->
<ng-template #brandSwitcherTemplate let-label="label" let-isActive="isActive">
  <div ngbDropdown container="body" class="d-inline-flex align-items-center brand-switcher">
    <span
      ngbDropdownToggle
      class="m-2 link-label pointer d-flex align-items-center"
      [class.active]="isActive"
      tabindex="0"
      role="button"
      [title]="'brandSwitcherLabel' | translate"
      [attr.aria-label]="'brandSwitcherLabel' | translate"
      ><span class="crumb-text">{{ label }}</span>
      <svg
        width="10"
        height="8"
        viewBox="0 0 7 6"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        class="ms-1"
        aria-hidden="true">
        <path d="M3.17773 5.52783L0.146646 0.277831L6.20882 0.277832L3.17773 5.52783Z" fill="black" fill-opacity="0.5" />
      </svg>
    </span>
    <div ngbDropdownMenu class="brand-switcher-menu">
      <button
        ngbDropdownItem
        *ngFor="let brand of brandService.brands()"
        type="button"
        class="d-flex align-items-center brand-switcher-item"
        [class.active]="brand.id === brandService.activeBrand()?.id"
        [title]="brand.name"
        (click)="selectBrand(brand)">
        <span class="_1-line-text-ellipsis">{{ brand.name }}</span>
        <i *ngIf="brand.id === brandService.activeBrand()?.id" class="fa fa-check ms-auto ps-2" aria-hidden="true"></i>
      </button>
    </div>
  </div>
</ng-template>

<ng-template #driveCompareChip>
  <button
    *ngIf="driveCompareActive()"
    type="button"
    class="drive-compare-chip ms-1"
    [title]="'drive_compareExit' | translate"
    [attr.aria-label]="'drive_compareExit' | translate"
    (click)="closeDriveCompare()">
    <span>{{ 'drive_compareLabel' | translate }}</span>
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" aria-hidden="true">
      <path d="M3.5 3.5L10.5 10.5M10.5 3.5L3.5 10.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" />
    </svg>
  </button>
</ng-template>
